import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps, ComponentPropsWithRef } from "react";

export function Dialog(props: ComponentProps<typeof DialogPrimitive.Root>) {
  return <DialogPrimitive.Root {...props} />;
}

export function DialogTrigger(
  props: ComponentPropsWithRef<typeof DialogPrimitive.Trigger>,
) {
  return <DialogPrimitive.Trigger {...props} />;
}

export function DialogPortal(
  props: ComponentProps<typeof DialogPrimitive.Portal>,
) {
  return <DialogPrimitive.Portal {...props} />;
}

export function DialogOverlay(
  props: ComponentPropsWithRef<typeof DialogPrimitive.Overlay>,
) {
  return <DialogPrimitive.Overlay {...props} />;
}

export function DialogContent(
  props: ComponentPropsWithRef<typeof DialogPrimitive.Content>,
) {
  return <DialogPrimitive.Content {...props} />;
}

export function DialogTitle(
  props: ComponentPropsWithRef<typeof DialogPrimitive.Title>,
) {
  return <DialogPrimitive.Title {...props} />;
}
